<template>
  <!--Элементы-->
  <div class="uk-width-1-1 uk-margin-medium-top">
    <div class="uk-background-muted uk-padding-small">
      <template v-if="editedFunction.elements && editedFunction.elements.length > 0">
        <div class="uk-margin-small uk-text-bold">Элементы
          ({{ editedFunction.elements ? editedFunction.elements.length : 0 }})
        </div>
        <div class="uk-panel-scrollable uk-height-medium_" style="height: 300px;">
          <div class="uk-grid uk-grid-collapse uk-grid-divider uk-margin-small uk-child-width-1-1" data-uk-grid>
            <!--существующий элемент 1-->
            <div v-for="(element, elKey) in editedFunction.elements" :key="elKey">
              <div class="uk-grid uk-grid-collapse tm-grid-bg-hover" data-uk-grid>
                <div class="uk-width-medium" :data-uk-tooltip="element.name">
                  <div class="uk-padding-xsmall uk-text-truncate">
                    {{ element.name }}
                  </div>
                </div>
                <div class="uk-width-expand" :data-uk-tooltip="'title: ' + element.image_path + ';offset: 5'">
                  <div class="uk-padding-xsmall uk-text-truncate">
                    {{ element.image_path }}
                  </div>
                </div>
                <div class="uk-width-auto">
                  <a :href="element.image_path"
                     target="_blank"
                     class="uk-link-text uk-padding-xsmall uk-display-inline-block"
                     data-uk-tooltip="Скачать файл"
                     :download="element.image_path.substring(element.image_path.lastIndexOf('/')+1)">
                    <md-icon>download</md-icon>
                  </a>
                </div>
                <div class="uk-width-auto">
                  <a :href="element.image_path"
                     class="uk-link-text uk-padding-xsmall uk-display-inline-block"
                     data-uk-tooltip="Открыть в новой закладке"
                     target="_blank">
                    <md-icon>open_in_new</md-icon>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr class="uk-margin">
      </template>
      <div class="uk-margin-small uk-text-bold">Добавить элемент</div>
      <div class="uk-text-muted tm-text-small uk-margin-small" style="line-height: 1.3">
        Допустимые форматы: .jpg, .jpeg, .png, .svg, .psd, .ai, .eps<br>
        После загрузки элемент будет добавленая в конце списка<br>
        Имя картинки будет переменовано в название_фукнкции_NNN.png, где NNN номер элемента по порядку
      </div>
      <!--блок загрузки нового элемента-->
      <div class="uk-grid uk-grid-small uk-flex-middle" data-uk-grid>
        <div class="uk-width-expand">
          <input type="text"
                 :value="editedFunction.name+'_'+getLastElementNumber()"
                 ref="newElementName"
                 :class="'uk-input ' + (elementErrors['name'] ? ' uk-form-danger ' : '')"
                 disabled>
        </div>
        <div class="uk-width-auto">
          <div data-uk-form-custom="target: true">
            <input ref="newElementImage" type="file" accept="image/*" aria-label="Custom controls" @change="checkFileSelection">
            <input :class=" (elementErrors.file ? ' uk-form-danger ' : '') + 'uk-input uk-form-width-medium '"
                   type="text"
                   placeholder="Выберите файл"
                   disabled>
            <button class="uk-button uk-button-default uk-button-small-padding"
                    type="button"
                    tabindex="-1">
              Выбрать фото
            </button>
          </div>
        </div>
        <!--кнопка добаления нового элемента-->
        <div class="uk-width-auto">
          <button v-if="isFileSelected" class="uk-button tm-button-success uk-button-small-padding"
                  type="button"
                  data-uk-toggle="target: .new-element; animation: uk-animation-fade"
                  data-uk-tooltip="Добавить элемент"
                  @click="saveNewElement(editedFunction.id)">
            <span class="tm-light" v-if="!loading">
              <md-icon>add</md-icon>
            </span>
            <span v-else class="uk-icon uk-spinner uk-margin-left" data-uk-spinner></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

const url = process.env.VUE_APP_API_BASE_URL;

export default {
  data() {
    return {
      elementErrors: {},
      loading: false,
      isFileSelected: false
    };
  },
  computed: {},
  props: {editedFunction: {type: [Object, Array]}},
  methods: {
    downloadItem(url, label) {
      fetch(url, {
        method: "GET"
      }).then(response => response.blob())
          .then(blob => {
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = url;
            a.download = label;
            document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
            a.click();
            a.remove();  //afterwards we remove the element again
          });
    },
    async saveNewElement(function_id) {
      this.elementErrors = {};
      if (this.$refs.newElementName.value === null || this.$refs.newElementName.value.trim() === '') {
        this.elementErrors.name = ['The name is required'];
        return;
      } else if (!this.$refs.newElementImage.files || this.$refs.newElementImage.files.length <= 0) {
        this.elementErrors.file = ['The file is required'];
        return;
      }
      this.loading = true;
      let data = new FormData();
      data.append('file', this.$refs.newElementImage.files[0])
      data.append('function_id', function_id)
      data.append('name', this.$refs.newElementName.value)

      await axios.post(`${url}/new_orders/add_func_element`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      }).then(async response => {
        await this.$store.dispatch('functionsEdit/functionsList');
        UIkit.notification({message: 'Element is saved', pos: 'top-center', status: 'success', timeout: 1500})
      }).catch(err => {
        this.elementErrors = err.response.data && err.response.data.errors ? err.response.data.errors : {};
        if (err.response.data && err.response.data.message) {
          UIkit.notification({message: err.response.data.message, pos: 'top-center', status: 'error', timeout: 1500})
        }
      });
      this.loading = false;
    },
    getElementNumber(name) {
      let result = name.match(/\d+/g)[0];
      return result ? Number.parseInt(result) : 0;
    },
    getLastElementNumber() {
      let elements = this.editedFunction.elements && this.editedFunction.elements.length > 0 ? this.editedFunction.elements : [];
      let number = 0;
      for (let i in elements) {
        if (elements[i] && elements[i].name && this.getElementNumber(elements[i].name) > number) {
          number = this.getElementNumber(elements[i].name);
        }
      }
      return number + 1;
    },
    checkFileSelection(event) {
      this.isFileSelected = event.target.files.length > 0;
    },
  }
}
</script>